export const UNITS = [
  { value: 'kg', label: 'kg' },
  { value: 'g', label: 'g' },
  { value: 'mg', label: 'mg' },
  { value: 'l', label: 'L' },
  { value: 'ml', label: 'mL' },
  { value: 'cl', label: 'cL' },
  { value: 'pz', label: 'pz' },
  { value: 'conf', label: 'conf.' },
  { value: 'vaschetta', label: 'vasc.' },
  { value: 'busta', label: 'busta' },
  { value: 'cartone', label: 'cart.' },
];

export const UNIT_VALUES = UNITS.map(u => u.value);

export const UNIT_ALIASES = {
  confezione:'conf', confezioni:'conf', pezzo:'pz', pezzi:'pz',
  litro:'l', litri:'l', millilitro:'ml', millilitri:'ml',
  centilitro:'cl', centilitri:'cl',
  grammo:'g', grammi:'g', milligrammo:'mg', milligrammi:'mg',
  chilogrammo:'kg', chilogrammi:'kg',
  vaschette:'vaschetta', buste:'busta', cartoni:'cartone',
};

export const normalizeUnitValue = value => UNIT_ALIASES[String(value || '').trim().toLowerCase()] || String(value || '').trim().toLowerCase();
export const limitUnitPrecision = (value, unit) => {
  const raw = String(value ?? '');
  if (!raw) return raw;
  const decimals = normalizeUnitValue(unit) === 'pz' ? 1 : 2;
  const separator = Math.max(raw.indexOf('.'), raw.indexOf(','));
  if (separator < 0) return raw;
  return `${raw.slice(0, separator)}.${raw.slice(separator + 1, separator + 1 + decimals)}`;
};

const UNIT_LABELS = Object.fromEntries(UNITS.map(unit => [unit.value, unit.label]));
export const formatUnitShort = value => {
  const normalized = normalizeUnitValue(value);
  return UNIT_LABELS[normalized] || String(value || '').trim() || '—';
};

const UNIT_FACTORS = {
  mg:['mass',0.001], g:['mass',1], kg:['mass',1000],
  ml:['volume',1], cl:['volume',10], l:['volume',1000],
  pz:['pieces',1], conf:['conf',1], vaschetta:['vaschetta',1], busta:['busta',1], cartone:['cartone',1],
};

export const convertUnitQuantity = (value, fromUnit, toUnit) => {
  const from=normalizeUnitValue(fromUnit),to=normalizeUnitValue(toUnit);
  const source=UNIT_FACTORS[from],target=UNIT_FACTORS[to];
  const numeric=Number(value);
  if(!Number.isFinite(numeric)||!source||!target||source[0]!==target[0])return null;
  return numeric*source[1]/target[1];
};
